

import {computed, defineComponent, PropType} from "vue";
import {SetupContext} from "@vue/runtime-core";
import {toFixed} from "@/utils/filter";

export default defineComponent({
  name: 'JPagination',
  props: {
    total: {
      required: false,
      type: [Number, String],
      default: null
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array as PropType<Array<Number>>,
      default() {
        return [1, 5, 10, 20, 30, 50]
      }
    },
    layout: {
      type: String,
      default: 'prev, pager, next'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },

  setup(props: any, context: SetupContext) {

    let currentPage = computed({
      get() {
        return props.page
      },
      set(val) {
        context.emit('update:page', val)
      }
    })

    let pageSize = computed({
      get() {
        return props.limit
      },
      set(val) {
        context.emit('update:limit', val)
      }
    })

    let handleSizeChange = (val: number) => {
      context.emit("update:total", props.total)
      context.emit('pagination', {page: currentPage.value, limit: val, total: props.total})
    }

    let handleCurrentChange = (val: number) => {
      context.emit("update:total", props.total)
      context.emit('pagination', {page: val, limit: pageSize.value, total: props.total})
    }

    let totalC = computed(() => {
      if (typeof props.total === 'string') {
        return parseInt(props.total)
      }
      return props.total || 0
    })


    return {
      currentPage,
      pageSize,
      handleSizeChange,
      handleCurrentChange,
      totalC
    }
  }
})
